module.exports = __webpack_public_path__ + "static/media/BankDetailUpload.d1192519.svg";